import { Loading } from '@design';
import React, { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router';

import { IB_OAUTH_CODE_EVENT } from '../../utils/oauth-ib-service';

export const InteractiveBrokersCallback = () => {
  const search = useLocation().search;
  const query = useMemo(() => {
    return new URLSearchParams(search);
  }, [search]);

  useEffect(() => {
    if (window.opener) {
      const event = new CustomEvent(IB_OAUTH_CODE_EVENT, {
        detail: {
          request_token: query.get('oauth_token'),
          verifier_token: query.get('oauth_verifier'),
        },
      });
      window.opener.dispatchEvent(event);
    }
  }, []);

  return <Loading />;
};
